import "./StyleNameHeader.0.css";
import FloatPortal from '../../../Portal/FloatPortal';
const __script_base__ = {
  components: {
    FloatPortal
  },
  props: {
    name: {
      type: String,
      required: false,
      default: ''
    },
    resetOption: {
      type: Object,
      required: false,
      default: null
    },
    helpText: {
      type: String,
      required: false,
      default: ''
    },
    changed: {
      type: Boolean,
      default: false
    },
    helpTextZIndex: {
      type: Number,
      required: false
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "uc-style-header",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c("label", [_vm._v("\n    " + _vm._s(_vm.name) + "\n  ")]), _vm._v(" "), _c("div", {
    staticClass: "content-slot"
  }, [_vm._t("content")], 2), _vm._v(" "), _vm.helpText ? _c("div", {
    staticStyle: {
      display: "inline-block",
      position: "relative"
    }
  }, [_c("i", {
    staticClass: "fa fa-info-circle uc-style-header-help",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c("FloatPortal", {
    staticClass: "uc-style-header-help-tip",
    attrs: {
      "z-index": _vm.helpTextZIndex
    }
  }, [_c("div", {
    staticClass: "uc-style-header-help-tip-display",
    domProps: {
      innerHTML: _vm._s(_vm.helpText)
    }
  })])], 1) : _vm._e(), _vm._v(" "), _vm.resetOption ? _c("div", {
    staticStyle: {
      float: "right",
      position: "relative",
      "margin-left": "4px"
    }
  }, [_c("i", {
    staticClass: "fa fa-undo uc-inputbox-reset-button",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      click: _vm.resetOption.resetCallback
    }
  }), _vm._v(" "), _c("div", {
    staticClass: "uc-inputbox-reset-tip"
  }, [_vm._v("\n      " + _vm._s(_vm.resetOption.resetTip) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "operation-slot"
  }, [_vm._t("operation")], 2), _vm._v(" "), _vm._t("default")], 2);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/PropPanel/StylePanel/comps/StyleNameHeader.vue",
  "_scopeId": "data-v-bf2d3114"
}, typeof __script__ === 'function' ? __script__.options : __script__);